import {Determinant} from "./determinant";
import {GeneralOperatorType} from "./general-operator";

export class MoneyDeterminant extends Determinant {

  public moneyValue: number;
  public operator: GeneralOperatorType;

}
